/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceGroupDetailsForAzure extends models.ResourceGroupDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("ResourceGroupDetailsForAzure");
    }

    getFixupPrototypeFunction() { return ResourceGroupDetailsForAzure.fixupPrototype; }

    static newInstance(model: Partial<ResourceGroupDetailsForAzure>): ResourceGroupDetailsForAzure {
        let obj = Object.assign(new ResourceGroupDetailsForAzure(), model);
        ResourceGroupDetailsForAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceGroupDetailsForAzure>): ResourceGroupDetailsForAzure {
        if (!model) return null;
        return ResourceGroupDetailsForAzure.newInstance(<ResourceGroupDetailsForAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceGroupDetailsForAzure) {
        if (!obj) return;

        models.ResourceGroupDetailsForAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceGroupDetailsForAzure): boolean {
        if (models.ResourceGroupDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceGroupDetailsForAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Location of resource group, if any.
     */
    location: string;

}
